import React from "react";
import { Grid, TextField, MenuItem, Chip, Box, Button } from "@mui/material";
import { Field } from "formik";
import { childrenOf } from "../helpers/productForm.utils";

export default function ProductCategoryFields({
  categories,
  values,
  errors,
  touched,
  setFieldValue,
}) {
  const rootCategories = categories.filter((c) => c.parentCategoryId == null);

  const getFinalSelectedCategoryId = () => {
    if (values.subCategoryId && Number(values.subCategoryId) !== 0) {
      return Number(values.subCategoryId);
    }

    if (values.categoryId && Number(values.categoryId) !== 0) {
      return Number(values.categoryId);
    }

    if (values.parentCategoryId && Number(values.parentCategoryId) !== 0) {
      return Number(values.parentCategoryId);
    }

    return 0;
  };

  const addCategoryToProduct = () => {
    const finalId = getFinalSelectedCategoryId();

    if (!finalId) return;

    const current = values.categoryIds || [];

    if (!current.includes(finalId)) {
      setFieldValue("categoryIds", [...current, finalId]);
    }

    // setFieldValue("parentCategoryId", 0);
    // setFieldValue("categoryId", 0);
    // setFieldValue("subCategoryId", 0);
  };

  const removeCategoryFromProduct = (id) => {
    setFieldValue(
      "categoryIds",
      (values.categoryIds || []).filter((x) => x !== id)
    );
  };

  return (
    <>
      {/* קטגוריה ראשית */}
      <Grid item xs={12} md={4}>
        <Field
          as={TextField}
          select
          name="parentCategoryId"
          label="קטגוריה ראשית"
          fullWidth
          value={values.parentCategoryId}
          onChange={(e) => {
            const newParentId = Number(e.target.value);

            setFieldValue("parentCategoryId", newParentId);
            setFieldValue("categoryId", 0);
            setFieldValue("subCategoryId", 0);
          }}
          helperText={
            touched.parentCategoryId && errors.parentCategoryId
              ? errors.parentCategoryId
              : ""
          }
          error={touched.parentCategoryId && Boolean(errors.parentCategoryId)}
        >
          <MenuItem value={0} disabled>
            בחרי קטגוריה ראשית
          </MenuItem>

          {rootCategories.map((cat) => (
            <MenuItem key={cat.id} value={cat.id}>
              {cat.nameCategor}
            </MenuItem>
          ))}
        </Field>
      </Grid>

      {/* תת קטגוריה */}
      <Grid item xs={12} md={4}>
        <Field
          as={TextField}
          select
          name="categoryId"
          label="תת קטגוריה"
          fullWidth
          value={values.categoryId}
          onChange={(e) => {
            setFieldValue("categoryId", Number(e.target.value));
            setFieldValue("subCategoryId", 0);
          }}
          disabled={
            !values.parentCategoryId ||
            childrenOf(categories, values.parentCategoryId).length === 0
          }
        >
          <MenuItem value={0} disabled>
            {childrenOf(categories, values.parentCategoryId).length
              ? "בחרי תת קטגוריה"
              : "אין תתי קטגוריות"}
          </MenuItem>

          {childrenOf(categories, values.parentCategoryId).map((sub) => (
            <MenuItem key={sub.id} value={sub.id}>
              {sub.nameCategor}
            </MenuItem>
          ))}
        </Field>
      </Grid>

      {/* תת תת קטגוריה */}
      <Grid item xs={12} md={4}>
        <Field
          as={TextField}
          select
          name="subCategoryId"
          label="תת תת קטגוריה"
          fullWidth
          value={values.subCategoryId}
          onChange={(e) => {
            setFieldValue("subCategoryId", Number(e.target.value));
          }}
          disabled={
            !values.categoryId ||
            childrenOf(categories, values.categoryId).length === 0
          }
        >
          <MenuItem value={0} disabled>
            {childrenOf(categories, values.categoryId).length
              ? "בחרי תת תת קטגוריה"
              : "אין תת תת קטגוריות"}
          </MenuItem>

          {childrenOf(categories, values.categoryId).map((sub2) => (
            <MenuItem key={sub2.id} value={sub2.id}>
              {sub2.nameCategor}
            </MenuItem>
          ))}
        </Field>
      </Grid>

      {/* כפתור הוספה */}
      <Grid item xs={12}>
        <Button
          variant="outlined"
          onClick={addCategoryToProduct}
          disabled={!getFinalSelectedCategoryId()}
        >
          הוסף קטגוריה למוצר
        </Button>
      </Grid>

      {/* קטגוריות שנבחרו */}
      <Grid item xs={12}>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {(values.categoryIds || []).map((id) => {
            const cat = categories.find((c) => c.id === id);

            return (
              <Chip
                key={id}
                label={cat?.nameCategor || id}
                onDelete={() => removeCategoryFromProduct(id)}
              />
            );
          })}
        </Box>
      </Grid>
    </>
  );
}